/**
 * FactList
 * This is a list of Fact components
 */
import { createStyles, makeStyles } from '@material-ui/core';
import React, { Fragment } from 'react';
import { Divider, Fact } from '../..';
const FactList = ({ facts }) => {
    const useStyles = makeStyles(() => createStyles({
        factList: {
            display: 'flex',
            justifyContent: 'space-evenly',
            alignItems: 'center',
            height: '37px',
        },
    }));
    const classes = useStyles();
    return (React.createElement("div", { className: classes.factList }, facts.map((fact, index) => {
        const { header, subheader } = fact;
        return (React.createElement(Fragment, { key: `${header}${subheader}${index}` },
            React.createElement(Fact, { header: header, subheader: subheader }),
            facts.length - index > 1 && React.createElement(Divider, { orientation: "vertical" })));
    })));
};
export { FactList };
//# sourceMappingURL=FactList.js.map